import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import SEOMeta from '@/components/feature/SEOMeta';

export default function About() {
  const breadcrumbItems = [
    { label: '首页', href: '/' },
    { label: '关于我们' },
  ];

  const orgStructuredData = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '五一吃瓜网',
    url: 'http://xjqkfyv.cn/',
    logo: 'http://xjqkfyv.cn/logo.png',
    description: '全国吃瓜群众聚集的爆料基地，每日更新网红黑料、明星秘闻、社会热点。',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: '商务合作',
      email: 'hello@xjqkfyv.cn',
      areaServed: 'CN',
      availableLanguage: 'Chinese',
    },
  };

  const aboutPageStructuredData = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于五一吃瓜网',
    url: 'http://xjqkfyv.cn/about',
    description: '五一吃瓜网是国内领先的娱乐爆料资讯平台，致力于为吃瓜群众提供最新、最全、最劲爆的八卦资讯。',
    publisher: {
      '@type': 'Organization',
      name: '五一吃瓜网',
    },
  };

  const faqStructuredData = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '五一吃瓜网是什么？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '五一吃瓜网是一个专注于娱乐八卦、网红黑料、社会热点爆料的中文资讯平台。我们致力于为吃瓜群众提供最新、最全、最劲爆的爆料内容。',
        },
      },
      {
        '@type': 'Question',
        name: '网站上的爆料内容真实吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '我们致力于发布经过多方核实的爆料内容，所有信息均来自公开渠道、知情人士透露或官方通报。对于无法完全核实的内容，我们会明确标注信息来源和可信度。',
        },
      },
      {
        '@type': 'Question',
        name: '如何向五一吃瓜网投稿爆料？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '您可以通过邮箱 hello@xjqkfyv.cn 向我们投稿爆料。请尽量提供详细的信息、图片或视频证据，我们会保护您的隐私安全。',
        },
      },
      {
        '@type': 'Question',
        name: '五一吃瓜网的内容更新频率如何？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '我们承诺每日更新，全年无休。无论是凌晨的突发爆料还是白天的热点追踪，五一吃瓜网永远在线，确保您第一时间吃到最新鲜的瓜。',
        },
      },
    ],
  };

  return (
    <>
      <SEOMeta
        title="关于我们 - 五一吃瓜网 | 品牌介绍、网站信誉与联系方式"
        description="了解五一吃瓜网的品牌故事、运营理念和联系方式。我们是全国吃瓜群众聚集的爆料基地，每日更新网红黑料、明星秘闻、社会热点。"
        keywords="五一吃瓜网,关于五一吃瓜网,吃瓜网站介绍,娱乐爆料平台,联系我们"
        canonical="http://xjqkfyv.cn/about"
        structuredData={[orgStructuredData, aboutPageStructuredData, faqStructuredData]}
      />

      <Navbar />

      <header className="relative w-full h-[400px] md:h-[500px] overflow-hidden mt-16 md:mt-20">
        <img
          src="https://readdy.ai/api/search-image?query=modern%20creative%20office%20workspace%20with%20warm%20natural%20light%2C%20team%20collaboration%20atmosphere%2C%20minimalist%20design%2C%20warm%20beige%20and%20amber%20tones%2C%20editorial%20photography%20with%20soft%20shadows&width=1600&height=600&seq=about-hero-01&orientation=landscape"
          alt="关于五一吃瓜网 - 我们的团队"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50" />
        <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4">
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white font-heading mb-3">
            关于五一吃瓜网
          </h1>
          <p className="text-base md:text-lg text-white/80 max-w-xl font-light">
            全国吃瓜群众最信赖的爆料资讯平台
          </p>
          <Link
            to="/"
            className="mt-6 inline-flex items-center gap-2 text-sm text-accent-300 hover:text-accent-200 transition-colors"
          >
            <i className="ri-arrow-left-line" />
            返回首页
          </Link>
        </div>
      </header>

      <main className="px-4 md:px-8 lg:px-12 py-8 md:py-12">
        <div className="max-w-6xl mx-auto">
          <Breadcrumb items={breadcrumbItems} />

          <section className="mt-8 md:mt-12">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16 items-start">
              <div>
                <span className="text-xs font-medium text-foreground-500 uppercase tracking-wider mb-2 block">
                  关于我们
                </span>
                <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 font-heading leading-snug mb-6">
                  吃瓜，我们是认真的
                </h2>
                <div className="space-y-4 text-foreground-700 leading-relaxed text-sm md:text-base">
                  <p>
                    五一吃瓜网成立于2020年，是国内领先的娱乐爆料资讯平台。我们的使命是为广大吃瓜群众提供最新、最全、最劲爆的八卦资讯，让每一位访客都能第一时间吃到最新鲜、最热乎的瓜。
                  </p>
                  <p>
                    从明星八卦到网红翻车，从社会热点到影视综艺内幕，我们的采编团队7×24小时全天候追踪全网动态，确保每一条爆料都经过严格筛选和核实。我们深知，在这个信息爆炸的时代，真实和时效就是吃瓜的生命线。
                  </p>
                  <p>
                    五一吃瓜网坚持独立、客观、公正的报道原则。我们不站队、不洗白、不抹黑，只做事实的搬运工和真相的探寻者。我们相信，吃瓜群众的眼睛是雪亮的，只有真实的内容才能赢得读者的长期信任。
                  </p>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div className="rounded-2xl overflow-hidden h-48 md:h-64">
                  <img
                    src="https://readdy.ai/api/search-image?query=creative%20newsroom%20team%20working%20at%20desks%20with%20multiple%20monitors%2C%20warm%20natural%20lighting%20from%20large%20windows%2C%20modern%20minimalist%20office%20interior%2C%20warm%20beige%20tones%2C%20editorial%20photography&width=600&height=500&seq=about-img-01&orientation=portrait"
                    alt="五一吃瓜网采编团队"
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div className="rounded-2xl overflow-hidden h-48 md:h-64 mt-6">
                  <img
                    src="https://readdy.ai/api/search-image?query=modern%20digital%20media%20command%20center%20with%20screens%20showing%20social%20media%20feeds%2C%20warm%20ambient%20lighting%2C%20sleek%20contemporary%20design%2C%20warm%20amber%20and%20neutral%20tones%2C%20editorial%20photography&width=800&height=500&seq=about-img-02&orientation=landscape"
                    alt="五一吃瓜网数据中心"
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
          </section>

          <section className="mt-16 md:mt-24 bg-background-100 rounded-2xl p-6 md:p-10">
            <h2 className="text-xl md:text-2xl font-bold text-foreground-900 font-heading mb-8 text-center">
              为什么选择五一吃瓜网
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {[
                {
                  icon: 'ri-flashlight-line',
                  title: '更新迅速',
                  desc: '全年365天不间断更新，热点事件发生后30分钟内上线报道',
                },
                {
                  icon: 'ri-shield-check-line',
                  title: '内容真实',
                  desc: '每条爆料均经过多源核实，拒绝谣言和虚假信息传播',
                },
                {
                  icon: 'ri-eye-line',
                  title: '视角独特',
                  desc: '深入挖掘事件背后的真相，提供普通渠道看不到的深度分析',
                },
                {
                  icon: 'ri-team-line',
                  title: '用户至上',
                  desc: '以用户体验为核心，简洁清爽的界面让吃瓜更舒心',
                },
              ].map((item, index) => (
                <div key={index} className="text-center">
                  <div className="w-12 h-12 flex items-center justify-center mx-auto mb-4">
                    <i className={`${item.icon} text-2xl text-accent-500`} />
                  </div>
                  <h3 className="text-base font-bold text-foreground-900 mb-2">{item.title}</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
                </div>
              ))}
            </div>
          </section>

          <section className="mt-16 md:mt-24">
            <h2 className="text-xl md:text-2xl font-bold text-foreground-900 font-heading mb-8 text-center">
              常见问题
            </h2>
            <div className="max-w-3xl mx-auto space-y-4">
              {[
                {
                  q: '五一吃瓜网是什么？',
                  a: '五一吃瓜网是一个专注于娱乐八卦、网红黑料、社会热点爆料的中文资讯平台。我们致力于为吃瓜群众提供最新、最全、最劲爆的爆料内容。',
                },
                {
                  q: '网站上的爆料内容真实吗？',
                  a: '我们致力于发布经过多方核实的爆料内容，所有信息均来自公开渠道、知情人士透露或官方通报。对于无法完全核实的内容，我们会明确标注信息来源和可信度。',
                },
                {
                  q: '如何向五一吃瓜网投稿爆料？',
                  a: '您可以通过邮箱 hello@xjqkfyv.cn 向我们投稿爆料。请尽量提供详细的信息、图片或视频证据，我们会保护您的隐私安全。',
                },
                {
                  q: '五一吃瓜网的内容更新频率如何？',
                  a: '我们承诺每日更新，全年无休。无论是凌晨的突发爆料还是白天的热点追踪，五一吃瓜网永远在线，确保您第一时间吃到最新鲜的瓜。',
                },
              ].map((faq, index) => (
                <div
                  key={index}
                  className="bg-background-50 rounded-xl p-5 md:p-6"
                  itemScope
                  itemType="https://schema.org/Question"
                >
                  <h3 className="text-base font-bold text-foreground-900 mb-2" itemProp="name">
                    {faq.q}
                  </h3>
                  <div itemScope itemType="https://schema.org/Answer">
                    <p className="text-sm text-foreground-600 leading-relaxed" itemProp="text">
                      {faq.a}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </section>

          <section className="mt-16 md:mt-24">
            <div className="bg-primary-500 rounded-2xl p-6 md:p-10">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
                <div>
                  <h2 className="text-xl md:text-2xl font-bold text-background-50 font-heading mb-4">
                    联系五一吃瓜网
                  </h2>
                  <div className="space-y-3 text-sm text-background-200">
                    <p>商务合作：hello@xjqkfyv.cn</p>
                    <p>爆料投稿：hello@xjqkfyv.cn</p>
                    <p>投诉建议：hello@xjqkfyv.cn</p>
                    <p className="pt-2">运营总部：中国 · 北京市朝阳区</p>
                  </div>
                </div>
                <div className="text-center md:text-right">
                  <p className="text-sm text-background-300 mb-4">
                    有任何问题或建议？欢迎随时联系我们
                  </p>
                  <a
                    href="mailto:hello@xjqkfyv.cn"
                    className="inline-flex items-center gap-2 bg-background-50 text-primary-500 px-6 py-2.5 rounded-full text-sm font-medium hover:bg-accent-100 transition-colors whitespace-nowrap"
                  >
                    <i className="ri-mail-line" />
                    发送邮件
                  </a>
                </div>
              </div>
            </div>
          </section>
        </div>
      </main>

      <Footer />
    </>
  );
}
